<!-- cart-list.component.html - Updated for line-based tracking -->

@if (vm(); as vm) {
    <section class="cart-wrapper" cdkTrapFocus cdkTrapFocusAutoCapture>
        @if (!vm.isEmpty) {
            <div class="cart-header" aria-label="Mini cart expanded">
                <div class="cart-title">
                    <h2 class="h1">Cart</h2>
                    <mat-icon class="close-icon" svgIcon="ico_close" (libAccessibleClick)="onClose()" />
                </div>

                <h2 class="subheading-1 n-count">You have {{ filteredProducts().length }} items in your cart.</h2>
            </div>
            <div class="product-list">
                @for (product of filteredProducts(); track product.lineNumber; let i = $index) {
                    <!-- RCP-452 — Apple uses the same quantity stepper as every other brand. -->
                    <lib-cart-item
                        mode="mobile"
                        [limitMessage]="productLimitMessage(product)"
                        [loading]="vm.loading"
                        [maxQuantity]="productMaxQuantity(product)"
                        [orderLimitReached]="isProductLimitReached(product)"
                        [product]="product"
                        [stockMessage]="productStockMessage(product, i)"
                        (quantityChange)="onUpdate($event)"
                        (remove)="onRemove($event)"
                    ></lib-cart-item>

                    <!-- RCP-306: engraving and AppleCare are not offered for the event, kept for later events.
                    Show skeleton loader for AppleCare section while capabilities are loading
                    @if (capabilitiesLoading() && isAppleProduct(product)) {
                        <div class="apple-care-loading">
                            <ngx-skeleton-loader
                                animation="progress-dark"
                                [count]="1"
                                [theme]="appleCareSkeletonConfig"
                            ></ngx-skeleton-loader>
                            <p class="body-2">Loading AppleCare options...</p>
                        </div>
                    }
                    -->
                }
            </div>

            <div class="actions" [class.loading]="vm.loading">
                @if (vm.loading) {
                    <ngx-skeleton-loader animation="progress-dark" [count]="1" [theme]="skeletonConfig" />
                } @else {
                    <div class="totals">
                        <p class="link">Subtotal</p>

                        <div class="values">
                            <!-- Prices are loaded in Shopping Dollars; shown as whole numbers, no US dollar equivalent. -->
                            @if (vm.productCard?.subtotalDiscountedPrice) {
                                <p class="values__price">
                                    <span class="cta"
                                        >{{ vm.productCard?.subtotalDiscountedPrice | appDigitsGrouping }}
                                        {{ rewardName() }}</span
                                    >
                                    <span class="old body-2"
                                        >{{ vm.productCard?.subtotalPrice | appDigitsGrouping }}
                                        {{ rewardName() }}</span
                                    >
                                </p>
                            } @else {
                                <p class="values__price">
                                    <span class="cta"
                                        >{{ vm.productCard?.subtotalPrice | appDigitsGrouping }}
                                        {{ rewardName() }}</span
                                    >
                                </p>
                            }
                            <p class="summary-returns-policy body-2">No returns or refunds.</p>
                        </div>
                    </div>
                    <div class="summary-actions">
                        <button
                            mat-stroked-button
                            type="button"
                            [attr.cdkFocusInitial]="autoFocusActions ? '' : null"
                            [disabled]="checkoutLoading()"
                            (click)="redirectToCheckout()"
                        >
                            Go to checkout
                        </button>
                        <button
                            mat-raised-button
                            type="button"
                            [disabled]="checkoutLoading()"
                            (click)="redirectToCart()"
                        >
                            See cart
                        </button>
                    </div>
                }
            </div>
        } @else {
            <div class="empty-state">
                <h2 class="h1 text">Your cart is empty.</h2>
                <button mat-raised-button type="button" (click)="redirectToHome()">Continue shopping</button>
            </div>
        }
    </section>
    <app-applecare-modal></app-applecare-modal>
}
